const ChairishContext = window.chairisher.context;

/**
 * @returns {string|undefined} The URL to use when redeeming rewards
 */
export default function getRewardsRedemptionUrl() {
    return ChairishContext.REWARD_REDEMPTION_URL;
}
